var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4984 7C13.225 7 12.9984 6.77333 12.9984 6.5V3H9.49835C9.22502 3 8.99835 2.77333 8.99835 2.5C8.99835 2.22667 9.22502 2 9.49835 2H13.4984C13.7717 2 13.9984 2.22667 13.9984 2.5V6.5C13.9984 6.77333 13.7717 7 13.4984 7Z",
    fill: "#43494F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.9983H2.5C2.22667 13.9983 2 13.7716 2 13.4983V9.49829C2 9.22496 2.22667 8.99829 2.5 8.99829C2.77333 8.99829 3 9.22496 3 9.49829V12.9983H6.5C6.77333 12.9983 7 13.225 7 13.4983C7 13.7716 6.77333 13.9983 6.5 13.9983Z",
    fill: "#43494F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L9.35355 7.35355C9.15829 7.54882 8.84171 7.54882 8.64645 7.35355C8.45118 7.15829 8.45118 6.84171 8.64645 6.64645L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645Z",
    fill: "#43494F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35355 8.64645C7.54882 8.84171 7.54882 9.15829 7.35355 9.35355L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L6.64645 8.64645C6.84171 8.45118 7.15829 8.45118 7.35355 8.64645Z",
    fill: "#43494F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeIcon);
export default __webpack_public_path__ + "static/media/maximize-icon.38f046f12934696e8a00b0555e032f49.svg";
export { ForwardRef as ReactComponent };